import { ref } from 'vue'
import { defineStore } from 'pinia'
import { GlobalMessage, MessageLevel } from '@/types'

export const useGlobalMsgStore = defineStore('message', () => {
  const messages = ref([] as Array<GlobalMessage>)
  const msgId = ref(0)

  const getMsgId = () => {
    msgId.value += 1
    return msgId.value
  }

  const addMessage = (msg: string, level: MessageLevel) => {
    const globalMesage = {
      id: getMsgId(),
      level: level,
      message: msg,
    }
    messages.value = ([] as Array<GlobalMessage>)
      .concat(messages.value, [globalMesage]).slice(-3)
    // 6秒後自動的に消える
    setTimeout(function() {
      removeMessage(globalMesage)
    }, 6000)
    // 画面トップに表示
    setTimeout(function() {
      window.scrollTo(0, 0);
    }, 100)
  }

  const addSuccess = (msg: string) => {
    addMessage(msg, 'success')
  }

  const addError = (msg: string) => {
    addMessage(msg, 'error')
  }

  // eslint-disable-next-line
  const addApiErrors = (errors: any) => {
    if (errors && 'detail' in errors) {
      // 500の場合エラー画面に遷移するので、わざわざここで表示する必要がない
      if (!('status_code' in errors && errors.status_code === 500)) {
        addMessage(errors.detail, "error")
      }
    }
  }

  const removeMessage = (msg: GlobalMessage) => {
    const idx = messages.value.findIndex(i => i.id === msg.id);
    if (idx >= 0) {
      messages.value.splice(idx, 1)
    }
  }

  const clearMessage = () => {
    messages.value = [];
  }

  return { messages, addSuccess, addApiErrors, addError, removeMessage, clearMessage }
})
